import { render, staticRenderFns } from "./icon-x.vue?vue&type=template&id=1c53e05b&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c53e05b', component.options)
    } else {
      api.rerender('1c53e05b', component.options)
    }
    module.hot.accept("./icon-x.vue?vue&type=template&id=1c53e05b&functional=true&", function () {
      api.rerender('1c53e05b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/svg/icon-x.vue"
export default component.exports